<drawer
    [title]="'Form history'"
    [isClosed]=false
    [showHeader]="true"
    [showHeaderButtons]="false"
    (closeEvent)="closeSection()"
    >
    <div class="drawer-content drawer-direct-content">
            <div
                *ngIf="formHistory && formHistory.length && !preview"
                class="pt-3 d-flex overflow-hidden mh-100 h-100 w-100 flex-column">
                <div class="">
                    <table class="table align-middle effects-table">
                        <thead>
                            <tr>
                                <th>
                                    {{ 'User' | translate }}
                                </th>
                                <th>
                                    {{ 'Created' | translate }}
                                </th>
                                <th class="cell-delete" *ngIf="!hidePreview"></th>
                                <th class="cell-delete"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="let item of formHistory; let i = index;">
                                <td>
                                    {{ item.createdBy }}<source-badge [source]="item.createdSource"></source-badge>
                                </td>
                                <td>
                                    {{ item.createdWhen | date: dateFormat }}
                                </td>
                                <td class="text-center" *ngIf="i === 0 && page === 0" [attr.colspan]="hidePreview ? 1 : 2">
                                    <button class="editBtn btn-light disabled"
                                        >{{ 'Current version' | translate }}
                                    </button>
                                </td>
                                <td class="text-center" *ngIf="!hidePreview && (i != 0 || page > 0)">
                                    <button 
                                        (click)="tryPreviewForm(item)"
                                        class="btn btn-default btn-sm"
                                        >{{ 'Preview' | translate }}
                                    </button>
                                </td>
                                <td class="text-center" *ngIf="i != 0 || page > 0">
                                    <button
                                        (click)="tryChangeForm(item)"
                                        class="btn btn-primary btn-sm mr-2"
                                        >{{ 'Apply' | translate }}
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="app-pagination m-0">
                    <ul class="pagination m-0">
                        <li class="page-item" *ngIf="page > 0">
                            <a class="page-link" (click)="getPage(page - 1)">
                            <span aria-hidden="true">&laquo;</span>
                            </a>
                        </li>
                        <li
                            *ngFor="let p of getPages()"
                            class="page-item"
                            [ngClass]="{'active': p === page}">
                            <a
                            (click)="getPage(p)"
                            class="page-link">
                            {{p + 1}}
                            </a>
                        </li>
                        <li class="page-item" *ngIf="page < maxPage">
                            <a class="page-link" (click)="getPage(page + 1)">
                            <span aria-hidden="true">&raquo;</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div
                *ngIf="tryItem && !preview"
                class="try">
                <div class="content">
                    <h4>
                        {{'Do you want to return the form to this state?' | translate}}
                    </h4>
                    <h5>{{tryItem.createdBy}}<source-badge [source]="tryItem.createdSource"></source-badge></h5>
                    <h6>{{tryItem.createdWhen | date: dateFormat}}</h6>
                    <div class="buttons">
                        <button
                            (click)="cancelTry()"
                            class="btn btn-default">
                            {{'Cancel' | translate}}
                        </button>
                        <button
                            (click)="onChangeForm()"
                            class="btn btn-primary btn-sm">
                            {{'Apply' | translate}}
                        </button>
                    </div>
                </div>
            </div>
            <drawer [title]="tryItem.createdBy + ' -  ' + (tryItem.createdWhen | date: dateFormat)"
                [isClosed]=false
                [showHeader]="true"
                [showHeaderButtons]="true"
                [hideCancel]="false"
                [hideSave]="true"
                [hideDelete]="true"
                [saveWithConfirmation]="true"
                [saveWithConfirmationLabel]="'Apply'"
                [saveWithConfirmationQuestion]="'Do you want to return the form to this state?'"
                (saveWithConfirmationEvent)="onChangeForm()"
                (closeEvent)="cancelPreview()"
                (cancelEvent)="cancelPreview()"
                *ngIf="tryItem && preview">
                <div class="drawer-content drawer-direct-content">
                    <div class="content">
                        <my-formio
                            *ngIf="formSchema"
                            [serviceId]="serviceId"
                            [determinantMapById]="determinantMapById"
                            [roleId]="roleId"
                            [formSchema]="formSchema"
                            [fileLinkableWithRequirement]="true"
                            formName="applicant"
                            class="form-preview">
                        </my-formio>
                    </div>
                </div>
            </drawer>
            <div *ngIf="formHistory && !formHistory.length"
                class="pt-3 d-flex overflow-hidden mh-100 h-100 w-100 flex-column">
                <div class="">
                    <h4>
                        {{'This form does not contain history!' | translate}}
                    </h4>
                </div>
            </div>
            <div *ngIf="hideLoading" class="d-flex justify-content-center">
                <i class="fad fa-spinner-third fa-spin"></i>
            </div>
    </div>
</drawer>